import { ConfirmModal } from '@/shared/ui/components';
import { t } from 'ttag';
import { useCompleteSupportRequest } from './useCompleteSupportRequest';

/**
 * Renders the landing screen confirming a support request has been completed. Waits for the hook's loaded flag before showing a buttonless Complete Request confirmation modal carrying the message the hook resolved.
 *
 * @returns The confirmation modal once loaded, otherwise nothing.
 */
const CompleteSupportRequest = () => {
  const { message, loaded } = useCompleteSupportRequest();

  return (
    loaded && (
      <ConfirmModal
        isOpen
        title={t`Complete Request`}
        question={message}
        hasNoButton
        width={520}
        centered={false}
      />
    )
  );
};

export default CompleteSupportRequest;
